class SessionStorageService {
  hasKey (key) {
    return window.sessionStorage.getItem(key) !== null
  }

  removeItem (key) {
    return window.sessionStorage.removeItem(key)
  }

  getItem (key) {
    const item = window.sessionStorage.getItem(key)

    return item !== null
      ? JSON.parse(item)
      : undefined
  }

  setItem (key, data) {
    window.sessionStorage.setItem(key, JSON.stringify(data))
  }

  clear () {
    window.sessionStorage.clear()
  }
}

export default new SessionStorageService()
